module.exports = __webpack_public_path__ + "images/banners/pasodash/macdash_banner_fd4b52f5bb8a3b53f4c1d5946a0dbd7a.jpg";